import { put, call, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { createAdminApi, adminListApi, ActiveAdminApi, DeleteAdminApi } from '../Api/api';
import {
    createAdminLoad, createAdminSuccess, createAdminFail,
    adminListLoad, adminListSuccess, adminListFailed, activeAdminSuccess, activeAdminLoad, deleteAdminLoad, deleteAdminSuccess
} from '../slices/admin.slice';


function* createAdminSaga(action) {
    try {
        const data = yield call(createAdminApi, action.payload);
        if (data.status === 0) {
            yield put(createAdminSuccess());
            toast.success(data?.result?.message);
        } else {
            yield put(createAdminFail());
            toast.error(data?.result?.message);
        }
    } catch (error) {
        yield put(createAdminFail());
        toast.error(error.message);
    }
}

function* adminListSaga(action) {
    try {
        const data = yield call(adminListApi, action.payload);
        if (data.status === 0) {

            yield put(adminListSuccess({ data: data.result.data }));
        } else {
            toast.error(data?.result?.message);
            yield put(adminListFailed());
        }
    } catch (error) {
        yield put(adminListFailed());
    }
}

function* activeAdminSaga(action) {
    try {

        const data = yield call(ActiveAdminApi, action.payload);
        if (data.status === 0) {
            yield put(activeAdminSuccess());
        } else {
            toast.error(data?.result?.message);
        }
    } catch (error) {
        toast.error(error);

    }
}

function* deleteAdminSaga(action) {
    try {
        const data = yield call(DeleteAdminApi, action.payload);
        if (data.status === 0) {
            yield put(deleteAdminSuccess());
            toast.success(data?.result?.message);
        } else {
            toast.error(data?.result?.message);
        }
    } catch (error) {
        toast.error(error);

    }
}

function* rootAdminSaga() {
    yield takeLatest(createAdminLoad.type, createAdminSaga);
    yield takeLatest(adminListLoad.type, adminListSaga);
    yield takeLatest(activeAdminLoad.type, activeAdminSaga);
    yield takeLatest(deleteAdminLoad.type, deleteAdminSaga);
}

export default rootAdminSaga;